import { render, staticRenderFns } from "./Presse.vue?vue&type=template&id=2d9b9a9c&scoped=true&"
import script from "./Presse.vue?vue&type=script&lang=js&"
export * from "./Presse.vue?vue&type=script&lang=js&"
import style0 from "./Presse.vue?vue&type=style&index=0&id=2d9b9a9c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b9a9c",
  null
  
)

export default component.exports